import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import SLAForm from "../components/contracts/sla/SLAForm";

const SLAFormAddorEdit = () => (
 <Container fluid className="main-content-container px-4 pb-1">
    {/* Page Header */}
    <Row noGutters className="page-header pt-4 pb-3">
      <PageTitle sm="4" title="SLA" className="text-sm-left" />
    </Row>
    <Row>
      <Col md="12">
        <SLAForm />
      </Col>
    </Row>
  </Container>
);

export default SLAFormAddorEdit;
